(function () {
/**
 * Blocks
 */ // const yourblock = require('./blocks/yourblock.js');
/**
 * Base JS
 */ // add dom ready class
const $44ae6d9db4eaca0f$var$body = document.querySelector("body");
$44ae6d9db4eaca0f$var$body.classList.add("body--is-dom-ready");
window.addEventListener("load", ()=>{
    $44ae6d9db4eaca0f$var$body.classList.add("body--is-loaded");
});
// Assuming site header is fixed, add a class to indicate when it's "stuck"
const $44ae6d9db4eaca0f$var$siteHeader = document.querySelector(".site-header");
const $44ae6d9db4eaca0f$var$siteHeaderPinnedThreshold = 20; // threshold in pixels that we'll switch to pinned
let $44ae6d9db4eaca0f$var$siteHeaderScrollTimeoutId = 0;
window.addEventListener("scroll", ()=>{
    $44ae6d9db4eaca0f$var$siteHeaderScrollTimeoutId && window.cancelAnimationFrame($44ae6d9db4eaca0f$var$siteHeaderScrollTimeoutId);
    $44ae6d9db4eaca0f$var$siteHeaderScrollTimeoutId = window.requestAnimationFrame(()=>{
        $44ae6d9db4eaca0f$var$siteHeader.classList.toggle("site-header--is-pinned", window.scrollY > $44ae6d9db4eaca0f$var$siteHeaderPinnedThreshold);
    });
}, false);
// Close mobile nav when clicking on a primary nav link
// This helps with cases where mobile nav includes anchor links
const $44ae6d9db4eaca0f$var$navStatusElement = document.querySelector(".site-header__mobile-nav-status");
const $44ae6d9db4eaca0f$var$siteNavlinks = document.querySelector(".site-header__nav-links");
$44ae6d9db4eaca0f$var$siteNavlinks.addEventListener("click", (e)=>$44ae6d9db4eaca0f$var$navStatusElement.checked && ($44ae6d9db4eaca0f$var$navStatusElement.checked = false));

})();
//# sourceMappingURL=index.js.map
